<template>
	<div class="m-4">
		<div class="text-subtitle-2">{{ $t("dashboard.eventSettings") }}</div>
		<div class="grid grid-cols-1 gap-4">
			<SoftSelect v-model="unit" :label="$t('dashboard.unit')" :items="units" />
		</div>
	</div>
</template>

<script lang="ts">
import { velocityUnits } from "@soft-db/data-formatter";
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { computed, defineComponent, PropType } from "vue";
import {
	defaultVibrationCriteriaDataOptions,
	VibrationCriteriaDataOptions,
} from "./vibration-criteria-data-options";

export default defineComponent({
	name: "VibrationCriteriaGraphDataConfig",
	props: {
		modelValue: {
			type: Object as PropType<VibrationCriteriaDataOptions>,
			default: () => ({ ...defaultVibrationCriteriaDataOptions }),
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const unit = useRefObjectSync(valueModel, "unit");

		const units = computed(() => [...velocityUnits]);

		return {
			unit,
			units,
		};
	},
});
</script>
